// extracted by mini-css-extract-plugin
export default {"tooltipLine":"style--tooltipLine--155b21","text":"style--text--887eca"};